var map = {
	"./autocred.svg": "453c",
	"./banco-do-brasil.svg": "c4dc",
	"./bmp.svg": "2d16",
	"./bmp/background.svg": "6bd9",
	"./bmp/logo.svg": "0c59",
	"./bradesco.svg": "5132",
	"./caixa-economica-federal.svg": "a40d",
	"./itau.svg": "6bf8b",
	"./nubank.svg": "108f",
	"./picpay.svg": "4179",
	"./santander.svg": "958d",
	"./sicoob.svg": "6eca",
	"./sicredi.svg": "2f1a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c06f";